import { useMemo } from 'react';
import { createSelector } from 'reselect';
import { useTranslate } from '@gameday/utils/hooks/useTranslate';

const getGame = (state) => {
    const translate = useTranslate();
    const {
        liveData,
        gamePk,
        gameData: {
            venue: {
                name = ''
            } = {},
            teams,
            status: {
                abstractGameState,
                codedGameState
            } = {},
            datetime: {
                officialDate = ''
            } = {}
        } = {}
    } = state?.gumbo || {};

    const {
        seoSitePrefix,
        siteLabel,
        language
    } = state?.config || {};

    const liveTeamsData = liveData?.linescore?.teams || {};
    const gameStateOverride = (codedGameState !== 'D') ? abstractGameState : 'postponed';
    const awayBrief = teams?.away?.teamName;
    const homeBrief = teams?.home?.teamName;
    const homeScore = liveTeamsData?.home?.runs;
    const awayScore = liveTeamsData?.away?.runs;
    let homeTeamScore = '';
    let awayTeamScore = '';

    if (typeof homeScore !== 'undefined') {
        homeTeamScore = homeScore + '';
    }

    if (typeof awayScore !== 'undefined') {
        awayTeamScore = awayScore + '';
    }

    let tkey = 'seo_' + gameStateOverride?.toLowerCase() + '_';

    if (seoSitePrefix) {
        tkey = seoSitePrefix + '_' + tkey;
    }

    const dateLists = officialDate.split('-');
    const dd = dateLists[2];
    const mm = dateLists[1];
    const yyyy = dateLists[0];
    const seoDate = (language === 'es') ? dd + '/' + mm + '/' + yyyy : mm + '/' + dd + '/' + yyyy;

    const replaceWith = {
        awayTeam: awayBrief,
        homeTeam: homeBrief,
        awayTeamScore: awayTeamScore + '',
        homeTeamScore: homeTeamScore + '',
        gameState: gameStateOverride,
        venue: name,
        siteLabel,
        gamePk,
        date: seoDate
    };
    const title = translate(tkey + 'title', '', replaceWith);
    const description = translate(tkey + 'description', '', replaceWith);
    const keywords = translate(tkey + 'keywords', '');

    return useMemo(() => {
        return {
            title,
            description,
            keywords,
            gamePk,
            gameState: abstractGameState
        };
    }, [
        title,
        description,
        keywords,
        gamePk,
        abstractGameState
    ]);
};

export const getSeoState = createSelector(
    [getGame],
    (gameInfo) => {
        return gameInfo;
    }
);
